import { Route, Routes } from "react-router-dom"
import Detail from "./views/Detail"
import List from "./views/List"
import PrintView from "./views/PrintView"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<Detail />} />
      <Route path="/:id/print" element={<PrintView />} />
    </Routes>
  )
}
